import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { createFileRoute } from '@tanstack/react-router';
import { BarChart3, BriefcaseBusiness, Clock, Layers } from 'lucide-react';

export const Route = createFileRoute('/admin-console/advanced/jobs')({
    staticData: {
        breadcrumb: {
            title: 'Background jobs',
            inactive: true,
        },
        ui: {
            icon: BriefcaseBusiness,
            title: 'Background jobs management',
            subtitle: 'Monitor and manage system background jobs across all queues',
            widthVariant: 'default',
            menuDescription: 'Recurring, on-demand, and dynamic jobs',
        },
    },
    component: JobsLayout,
});

function JobsLayout() {
    return (
        <PageController route={Route}>
            <Tabs
                items={[
                    {
                        to: '/admin-console/advanced/jobs/recurring',
                        label: 'Recurring Jobs',
                        icon: <Clock size={16} />,
                    },
                    {
                        to: '/admin-console/advanced/jobs/on-demand',
                        label: 'On-Demand Jobs',
                        icon: <Layers size={16} />,
                    },
                    {
                        to: '/admin-console/advanced/jobs/dynamic-recurring',
                        label: 'Dynamic Recurring',
                        icon: <BarChart3 size={16} />,
                    },
                ]}
                size="large"
            />
        </PageController>
    );
}
